<div>
  <!-- Upload file -->
  <div
    [ngClass]="{
      'd-inline-block me-2': isNew === false,
      'is-invalid': invalid === true,
    }"
  >
    <div class="file-select d-inline">
      <portal-file-select
        [accept]="accept"
        [btnClass]="invalid ? 'btn-outline-danger' : 'btn-outline-secondary'"
        (onFileChanged)="setFile($event)"
      >
        <i class="far fa-fw fa-arrow-from-bottom"></i>

        @if (isNew) {
          {{ 'common.fileUploadDownload.add' | translate }}
        } @else {
          {{ 'common.fileUploadDownload.update' | translate }}
        }
      </portal-file-select>

      @if (file != null) {
        <code class="ms-1">
          {{ file.name }}
        </code>
      }
    </div>

    @if (invalid === true) {
      <div class="invalid-feedback">
        {{ 'general.form.message.required' | portalTranslate }}
      </div>
    }
  </div>

  <!-- Play file -->
  @if (isNew === false) {
    <portal-play-file
      class="me-1"
      [file]="downloadUrl"
      [portalTippy]="'common.fileUploadDownload.play' | translate"
    ></portal-play-file>
  }

  <!-- Download file -->
  @if (isNew === false) {
    <portal-file-download
      [portalTippy]="'common.fileUploadDownload.download' | translate"
      [url]="downloadUrl"
      btnClass="btn--portal-link"
    >
      <i class="far fa-fw fa-arrow-to-bottom"></i>
      @if (fileName != null) {
        <code class="ms-1">({{ fileName }})</code>
      }
    </portal-file-download>
  }

  <!-- Delete announcement -->
  @if (isNew === false) {
    <portal-icon-button
      [loading]="removing"
      [portalTippy]="'common.fileUploadDownload.delete' | translate"
      (onClick)="delete()"
      iconClass="far fa-fw fa-trash px-1"
      variant="danger"
    ></portal-icon-button>
  }

  <p>
    <small>{{ info }} </small>
  </p>
</div>
